/**
 * Dustrato Kinetic System - theme.js
 * Shopify AJAX cart, quantity, variant sync - Stitch-compatible
 */
document.addEventListener('DOMContentLoaded', () => {
  // Quantity input delegation for cart
  document.addEventListener('click', async (e) => {
    const minus = e.target.closest('button[name="minus"]');
    const plus = e.target.closest('button[name="plus"]');
    if (!minus && !plus) return;

    const input = e.target.closest('quantity-input')?.querySelector('input') || e.target.closest('.flex')?.querySelector('input[name="updates[]"]');
    if (!input) return;

    const current = parseInt(input.value || '1', 10);
    const next = minus ? Math.max(0, current - 1) : current + 1;
    input.value = next;

    // Auto-submit cart change via fetch
    const index = input.dataset.index;
    if (index) {
      try {
        const res = await fetch(`${window.routes.cart_change_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: parseInt(index, 10), quantity: next })
        });
        const data = await res.json();
        if (data.item_count !== undefined) {
          window.location.reload();
        }
      } catch (err) {
        window.location.reload();
      }
    }
  });

  // Add to cart intercept for product cards (enhance with fetch, fallback to form post)
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      const submitter = e.submitter;
      if (submitter && submitter.name === 'buy_now') return; // let buy now redirect

      // Optional: AJAX add without leaving page (comment out to keep traditional POST)
      // e.preventDefault();
      // const formData = new FormData(form);
      // await fetch(window.routes.cart_add_url, { method: 'POST', body: formData });
      // window.location.href = window.routes.cart_url;
    });
  });

  // Thumbnail gallery switch on PDP
  document.querySelectorAll('[data-media-id]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const main = document.getElementById('MainProductImage');
      const img = btn.querySelector('img');
      if (main && img) {
        const src = img.getAttribute('src') || img.currentSrc;
        if (src) main.src = src.replace(/width=\d+/, 'width=1200');
        document.querySelectorAll('[data-media-id]').forEach(b => {
          b.className = 'w-24 h-24 md:w-32 md:h-32 flex-shrink-0 border border-outline hover:border-primary opacity-70 hover:opacity-100 snap-start focus:outline-none focus:ring-2 focus:ring-secondary-container transition-all';
        });
        btn.className = 'w-24 h-24 md:w-32 md:h-32 flex-shrink-0 border-2 border-primary snap-start focus:outline-none focus:ring-2 focus:ring-secondary-container transition-all';
      }
    });
  });
});

// Shopify common helpers
window.onCartRefresh = () => window.location.reload();

/* Dustrato v3 motion: scroll reveals, 3D tilt, hero parallax */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('in'); });
    return;
  }

  // Stagger reveals inside grouped sections
  document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
    group.querySelectorAll('[data-reveal]').forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i * 90, 540) + 'ms';
    });
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });

  // 3D tilt on imagery (fine pointers only)
  if (window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('[data-tilt]').forEach(function (card) {
      var raf = null;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.transform = 'perspective(900px) rotateX(' + (-y * 7).toFixed(2) + 'deg) rotateY(' + (x * 9).toFixed(2) + 'deg)';
        });
      });
      card.addEventListener('mouseleave', function () {
        cancelAnimationFrame(raf);
        card.style.transform = '';
      });
    });
  }

  // Hero video parallax + content drift
  var heroVideo = document.querySelector('.hero-transparent video');
  var heroContent = document.querySelector('.hero-transparent .relative.z-10');
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking || (!heroVideo && !heroContent)) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      var vh = window.innerHeight;
      if (y < vh * 1.2) {
        if (heroVideo) heroVideo.style.transform = 'translateY(' + (y * 0.22) + 'px) scale(1.1)';
        if (heroContent) {
          heroContent.style.transform = 'translateY(' + (y * 0.12) + 'px)';
          heroContent.style.opacity = Math.max(0, 1 - y / (vh * 0.85));
        }
      }
      ticking = false;
    });
  }, { passive: true });
})();
